<template>
	<button
		type="button"
		class="relative inline-flex items-center justify-center text-white transition-colors rounded-full size-10 hover:bg-[#1F1F1F]"
		:aria-label="$t('general.notifications')"
		data-test="notification-bell"
		@click="$emit('click', $event)"
	>
		<IconBell />

		<!-- Counter -->
		<span
			v-if="count > 0"
			class="absolute inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 text-[0.6875rem] font-semibold leading-none text-white -top-1 -right-1 rounded-full bg-red-500"
			data-test="notification-badge"
		>
			{{ displayCount }}
		</span>
	</button>
</template>

<script>
import { IconBell } from '~/components/Icons'

export default {
	name: 'NotificationsBellButton',
	components: {
		IconBell
	},
	props: {
		count: {
			type: Number,
			default: 0
		}
	},
	computed: {
		displayCount() {
			return this.count > 99 ? '99+' : String(this.count)
		}
	}
}
</script>
